/**
 * Model for departuretime
 */
export class DepartureTimeModel {
  public DisplayDate: string;
  public Epoch: number;

  // constructor(displayDate: string, epoch: number) {
  //     this.DisplayDate = displayDate;
  //     this.Epoch = epoch;
  // }
}
